const TenantAllRoleList = `query tenantAllRoleList($tenantId: Int!){
  tenantAllRoleList(tenantId: $tenantId){
    roleId
    roleName
    desc
    updateDate
    deletable
  }
}`;

const AddTenantRole = `mutation addTenantRole(
  $tenantId: Int!,
  $name: String!,
  $desc: String
  ){
  addTenantRole(
    tenantId: $tenantId,
    name: $name,
    desc: $desc
  ){
    tenantRole{
      roleId
      roleName
      desc
    }
  }
}`;

const UpdateTenantRole = `mutation updateTenantRole(
  $roleId:Int!,
  $name: String,
  $desc: String
  ){
  updateTenantRole(
    roleId: $roleId,
    name: $name,
    desc: $desc
  ){
    tenantRole{
      roleId
      roleName
      desc
    }
  }
}`;

const DeleteTenantRole = `mutation deleteTenantRole(
  $roleId:Int!
  ){
  deleteTenantRole(
    roleId: $roleId,
  ){
    response
  }
}`;

module.exports = {
  TENANT_ALL_ROLES_QUERY: TenantAllRoleList,
  TENANT_ADD_ROLE_MUTATION: AddTenantRole,
  TENANT_UPDATE_ROLE_MUTATION: UpdateTenantRole,
  TENANT_DELETE_ROLE_MUTATION: DeleteTenantRole,
};
